import dayjs, { ManipulateType } from 'dayjs'; // TODO: try to remove dayJs dependency

import { MatchStatusType, FIRSTHALF, SECONDHALF, EXTRAFIRSTHALF, EXTRASECONDHALF } from '../typings/match';

export interface IMatchTime {
  timeStatusType: MatchStatusType;
  timeStart: number;
  timeEnd: number;
  timeLength: number;
}

const timerMatchTimes: Array<IMatchTime> = [
  {
    timeEnd: 45,
    timeLength: 45,
    timeStart: 1,
    timeStatusType: FIRSTHALF,
  },
  {
    timeEnd: 90,
    timeLength: 45,
    timeStart: 46,
    timeStatusType: SECONDHALF,
  },
  {
    timeEnd: 105,
    timeLength: 15,
    timeStart: 91,
    timeStatusType: EXTRAFIRSTHALF,
  },
  {
    timeEnd: 120,
    timeLength: 15,
    timeStart: 106,
    timeStatusType: EXTRASECONDHALF,
  },
];

export const filterMatchTime = (
  matchStatusType: MatchStatusType,
  matchTimes: Array<IMatchTime> = timerMatchTimes
): Array<IMatchTime> => matchTimes.filter((item) => item.timeStatusType === matchStatusType);

/**
 * Get match current minute
 * @param {String} dateFrom - Starting period time in ISO-8601 format (from BE)
 * @param {String} dateTo - Current period time in ISO-8601 format (from local O.S. or, better, fetching Web Service with timezone)
 * @param {MatchStatusType} matchStatusType - Current period
 */
export interface IGetMatchTime {
  matchStatusType: MatchStatusType;
  dateFrom: string;
  dateTo: string;
  maxStoppageMinutes?: number;
  interval?: number;
  unit?: ManipulateType;
}
export const getMatchTime = ({
  matchStatusType,
  dateFrom,
  dateTo,
  maxStoppageMinutes, // Expressed in MINUTES, just like "dateDiff"
  interval = 0,
  unit = 'minutes',
}: IGetMatchTime): string | undefined => {
  const matchTime: Array<IMatchTime> = filterMatchTime(matchStatusType);

  // Returns a MATCH TIME only for timeStatusType in IMatchTime[] array
  if (matchTime.length === 0) {
    return;
  }

  const dayjsFrom = dayjs(dateFrom);
  if (!dayjsFrom.isValid()) {
    return;
  }

  const dayjsTo: dayjs.Dayjs = dayjs(dateTo).add(interval, unit); // You can ADD an INTERVAL, e.g. from a TIMER

  // If NEGATIVE TIMING -> Don't SHOW timing!
  const dateDiffSeconds: number = dayjsTo.diff(dayjsFrom, 'seconds');
  if (dateDiffSeconds < 0) {
    console.warn('getMatchTime', { dateFrom, dateTo, dateDiffSeconds }); // eslint-disable-line no-console
    return;
  }

  // TIMING in MINUTES
  const dateDiff: number = dayjsTo.diff(dayjsFrom, 'minute');
  const { timeEnd, timeLength, timeStart } = matchTime[0];
  if (dateDiff >= timeLength) {
    // If STOPPAGE TIME is > (e.g.) 10 mins, then HIDE TIMINGS!
    const timeStoppage = dateDiff - timeLength + 1; // To avoid "0 minutes" text display
    return maxStoppageMinutes && timeStoppage > maxStoppageMinutes ? undefined : `${timeEnd}+${timeStoppage}'`;
  }

  return `${timeStart + dateDiff}'`;
};
